.root {
  width: 100%;
}

.svg {
  width: 100%;
  height: 3.5rem;
  background: var(--tuna-surface-elevated);
  border-radius: var(--tuna-shape-borderRadius);
  border: 1px solid var(--tuna-border-subtle);
}

.bar {
  fill: var(--tuna-palette-info-main);
  cursor: ns-resize;
  outline: none;
}

.barSelected {
  fill: var(--tuna-palette-info-dark);
  stroke: var(--tuna-content-primary);
  stroke-width: 0.5;
}

.bar:focus-visible {
  stroke: var(--tuna-content-primary);
  stroke-width: 0.8;
}

.baseline {
  stroke: var(--tuna-border-subtle);
  stroke-width: 0.5;
}

.empty {
  color: var(--tuna-content-muted);
  font-size: var(--tuna-typography-body2-fontSize);
  padding: var(--tuna-spacing-1);
}
